import { IconDisabledBackwardArrow, IconForwardArrow } from "@repo/assets/images";
import cx from "classnames";
const ThumbsCarouselButton = ({
  direction,
  children,
  className,
  ...restProps
}) => {
  const isPrev = direction === "prev";
  return <button className={`group ${className}`} type="button" {...restProps} aria-label={direction} data-sentry-component="ThumbsCarouselButton" data-sentry-source-file="ThumbsCarouselButton.jsx">
      <IconForwardArrow className={cx("group-disabled:hidden", {
      "-rotate-90": isPrev,
      "rotate-90": !isPrev
    })} data-sentry-element="IconForwardArrow" data-sentry-source-file="ThumbsCarouselButton.jsx" />
      <IconDisabledBackwardArrow className={cx("hidden group-disabled:block", {
      "-rotate-90": !isPrev,
      "rotate-90": isPrev
    })} data-sentry-element="IconDisabledBackwardArrow" data-sentry-source-file="ThumbsCarouselButton.jsx" />
      {children}
    </button>;
};
export default ThumbsCarouselButton;